import React from 'react';

export const Landing: React.FC = () => {
  const productBackground = process.env.REACT_APP_BACKGROUND || '#539A61';
  const developBackground = process.env.REACT_APP_BACKGROUND || '#4d7298';

  const backgroundColor =
    process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test'
      ? developBackground
      : productBackground;

  return (
    <div className="pb-5">
      <div className="main-banner" style={{ backgroundColor: backgroundColor }}>
        <div className="anime-title">
          <h1 className="mb-5">Specjalistyczna Platforma Diagnostyczna</h1>
          {process.env.REACT_APP_INSTANCE && (
            <h2>{process.env.REACT_APP_INSTANCE}</h2>
          )}
          <h2>Portal wewnętrzny</h2>
        </div>
      </div>
    </div>
  );
};
